<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">
                <ng-container>
                    {{'selectBoat' | translate}}
                </ng-container>
            </h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="m-0" fusePerfectScrollbar>

        <mat-table class="boats-list" [dataSource]="dataSource" matSort matSortActive="name" matSortDisableClear
                   matSortDirection="asc" fusePerfectScrollbar>

            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'boatName' | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let boat">
                    <p class="text-truncate">{{boat.name}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="licensePlate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Kennzeichen</mat-header-cell>
                <mat-cell *matCellDef="let boat">
                    <p class="text-truncate">{{boat.licensePlate}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Typ</mat-header-cell>
                <mat-cell *matCellDef="let boat">
                    <p class="text-truncate">{{boat.type}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="length">
                <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" fxShow.gt-md
                                 fxLayoutAlign="flex-end center">{{ 'boats.lengthM' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let boat" fxLayoutAlign="flex-end center">
                    <p class="phone text-truncate">
                        {{boat.length | number : '1.1-4'}}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="width">
                <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" fxShow.gt-lg
                                 fxLayoutAlign="flex-end center">{{ 'boats.widthM' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let boat" fxLayoutAlign="flex-end center">
                    <p class="job-title text-truncate">
                        {{boat.width | number : '1.1-4'}}
                    </p>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let boat; columns: displayedColumns;" [attr.data-test]="'TZ-Boot-' + boat.name"
                     class="boat" (click)="selectBoat(boat)">
            </mat-row>
        </mat-table>
    </div>
</div>
